// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/*######################################################################
  S A V E   F O O T E R
/*####################################################################*/


#avp-footer-save-container{
    position: fixed;
    bottom: 0;
    width: 100%;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 20px;
    padding-bottom: 10px;
    background: #FFFFFF;
    max-height: 80px;
  }
  
  #avp-footer-save-container-left{
    float: left;
    width: auto;
  }
  
  #avp-footer-save-container-right{
    float: right;
    width: auto;
    text-align: right;
  }

  #avp-footer-save-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    text-align: left;
    color: #282828;
  }

  #avp-footer-save-subtitle {
    font-size: 14px;
    font-style: italic;
    font-weight: 700;
    line-height: 21px;
    text-align: left;
    color: #282828;
  }

  #avp-footer-save-cancel {
    position: relative;
    float: right;
  }

  #avp-footer-save-cancel button {
    min-width: 150px;
    border: 1px solid #FFD54F;
    background-color: #ffffff;
    color: #FFD54F;
  }
  
  #avp-footer-save-submit {
    position: relative;
    float: right;
    margin-left: 20px;
  }
  
  #avp-footer-save-submit button {
    min-width: 150px;
  }

  @media screen and (max-width: 1199px) and (min-width: 992px){
  
  }
  
  
  
  @media screen and (max-width: 991px) and (min-width: 768px){
    
  }
  
  
  
  @media screen and (max-width: 767px) and (min-width: 576px){
   
  }
  
  
  
  @media only screen and (max-width: 575px){

  }`, "",{"version":3,"sources":["webpack://./src/shared/footer/avp_savefooter.css"],"names":[],"mappings":";;AAEA;;uEAEuE;;;AAGvE;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA","sourcesContent":["\r\n\r\n/*######################################################################\r\n  S A V E   F O O T E R\r\n/*####################################################################*/\r\n\r\n\r\n#avp-footer-save-container{\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%;\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    padding-top: 20px;\r\n    padding-bottom: 10px;\r\n    background: #FFFFFF;\r\n    max-height: 80px;\r\n  }\r\n  \r\n  #avp-footer-save-container-left{\r\n    float: left;\r\n    width: auto;\r\n  }\r\n  \r\n  #avp-footer-save-container-right{\r\n    float: right;\r\n    width: auto;\r\n    text-align: right;\r\n  }\r\n\r\n  #avp-footer-save-title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    line-height: 30px;\r\n    text-align: left;\r\n    color: #282828;\r\n  }\r\n\r\n  #avp-footer-save-subtitle {\r\n    font-size: 14px;\r\n    font-style: italic;\r\n    font-weight: 700;\r\n    line-height: 21px;\r\n    text-align: left;\r\n    color: #282828;\r\n  }\r\n\r\n  #avp-footer-save-cancel {\r\n    position: relative;\r\n    float: right;\r\n  }\r\n\r\n  #avp-footer-save-cancel button {\r\n    min-width: 150px;\r\n    border: 1px solid #FFD54F;\r\n    background-color: #ffffff;\r\n    color: #FFD54F;\r\n  }\r\n  \r\n  #avp-footer-save-submit {\r\n    position: relative;\r\n    float: right;\r\n    margin-left: 20px;\r\n  }\r\n  \r\n  #avp-footer-save-submit button {\r\n    min-width: 150px;\r\n  }\r\n\r\n  @media screen and (max-width: 1199px) and (min-width: 992px){\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 991px) and (min-width: 768px){\r\n    \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 767px) and (min-width: 576px){\r\n   \r\n  }\r\n  \r\n  \r\n  \r\n  @media only screen and (max-width: 575px){\r\n\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
